<template>
  <div class="serviceNas">
    <a href="https://glhs.quickconnect.cn/" target="_blank">点击打开Nas网络存储服务</a>
  </div>
</template>

<script>

export default {
  data() {
    return {

    }
  },
  created() {
    var url = 'https://glhs.quickconnect.cn/'
     var a = document.createElement('a')
     var event = new MouseEvent('click')
     a.href = url
     a.target = '_blank'
     a.dispatchEvent(event)
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
  a{color:#00b1c3}
</style>
